<ts-dialog [suppressHeader]="true">
  <form class="w-full flex flex-col gap-2" ts-dialog-body [formGroup]="teamsForm">
    @if (teamsOptions$ | async) {
      <ts-input formControlName="name" variant="slim" size="lg" placeholder="Team name" />
      <div class="flex flex-row items-center justify-between">
        <p class="flex flex-row items-center gap-1">
          Parent team
          <a class="flex flex-row items-center" href="https://help.termsheet.com/creating-teams" target="_blank">
            <ts-icon color="gray" icon="ts_question-circle" />
          </a>
        </p>
        <ts-select
          itemKey="value"
          itemLabel="label"
          formControlName="parent_id"
          class="w-1/2"
          [tooltip]="disableTooltipMessage | async"
          [hasGroups]="false"
          [disabled]="this.teamsForm.get('parent_id').disabled"
          [uiOptions]="{
            roundedBorders: false,
            placeholder: (teamsOptions$ | async) ? 'Select a team' : 'Loading...',
            searchPlaceholder: 'Team name...',
            size: 'full',
          }"
          [items]="teamsOptions$ | async"
        ></ts-select>
      </div>
    } @else {
      <ts-skeleton height="56"></ts-skeleton>
      <ts-skeleton height="36"></ts-skeleton>
    }
  </form>

  <div class="ts-dialog-actions-container" ts-dialog-actions>
    <ts-button variant="secondary" (click)="closeDialog()">Cancel</ts-button>
    <ts-button
      variant="primary"
      [disabled]="teamsForm.invalid || teamsForm.pristine"
      (click)="
        closeDialog({
          name: teamsForm.value.name,
          parent_id: teamsForm.value.parent_id ? +teamsForm.value.parent_id : editableTeam?.parent_id,
        })
      "
      >{{ saveButtonLabel }}
    </ts-button>
  </div>
</ts-dialog>
